import { gql } from '@apollo/client';

export const LIST_EXPORTED_PDF_DOCUMENTS_QUERY = gql`
  # Write your query or mutation here
  query ListExportedPdfDocuments($hotelId: ID!, $type: ENUM_DAILYCHIRP_TYPE) {
    dailychirps(
      where: { hotel: $hotelId, pdfDocuments_null: false, type: $type }
      sort: "date:desc"
      limit: 3
    ) {
      id
      date
      type
      title
      pdfDocuments
    }
  }
`;
